import { bootstrapApplication } from '@angular/platform-browser';

import { SHOW_CHAT_WIDGET, SHOW_OQAABI_LANDING } from '../landing-transfer/src/app/temp-feature-flags';

// TEMP: Oqaabi landing page switch. Remove after campaign.
async function bootstrapTempApp(): Promise<void> {
    if (SHOW_OQAABI_LANDING) {
        const [{ TempOqaabiLandingShellComponent }, { tempOqaabiLandingConfig }] = await Promise.all([
            import('../landing-transfer/src/app/temp-oqaabi-landing-shell.component'),
            import('../landing-transfer/src/app/temp-oqaabi-landing.config'),
        ]);

        await bootstrapApplication(TempOqaabiLandingShellComponent, tempOqaabiLandingConfig);
        return;
    }

    if (SHOW_CHAT_WIDGET) {
        const [{ AppComponent }, { appConfig }] = await Promise.all([
            import('./app/app.component'),
            import('./app/app.config'),
        ]);

        await bootstrapApplication(AppComponent, appConfig);
    }
}

bootstrapTempApp().catch((err) => console.error(err));
